import {ReactNode} from 'react';
import {t} from '../../../../common/getTranslations';
import {requestContext} from '../../../../common/requestContext';
import {showSimpleDialog} from '../../../../dialog/simpleDialogHandler';
import {Maybe} from '../../../../graphql/generated/types';
import {Icon} from '../../../atoms/Icon/Icon';
import {IconType} from '../../../atoms/Icon/IconType.enum';

export function Title({
  children,
  helpDescription,
}: {
  children: ReactNode;
  helpDescription?: Maybe<string>;
}) {
  return (
    <div className="flex h-50pxr">
      <div className="font-medium1-bold w-full self-center overflow-hidden text-ellipsis text-theme-solid-100 line-clamp-1">
        {children}
        {helpDescription && (
          <Icon
            type={IconType.ButtonHelpM}
            className="ml-4px inline cursor-pointer pb-3px"
            onClick={() => {
              showSimpleDialog({
                isMobile: requestContext.requestInfo.display.isMobile,
                title: '',
                description: helpDescription,
                okButton: {
                  text: t('common_confirm_button'),
                  type: 'label',
                  closeAfterClick: true,
                },
              });
            }}
          />
        )}
      </div>
    </div>
  );
}
